import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { ThemeContext } from 'styled-components';

const HeaderRelatorioTurma = ({
  schoolName,
  NameTurma,
  dreAndMunicipio,
  DsAno,
  DsPeriodo,
  student,
  disableSchoolYear,
  SchoolYear,
  disableDreAndMunicipio,
  disableSchoolName,
  disableStudent,
  disableDreTipoDeProva,
  disableDreAno
}) => {
  const theme = useContext(ThemeContext);
  return (
    <>
      <div
        className="container__background"
        style={{ background: `${theme.primary}` }}
      >
        <div className="basic__info">
          {disableSchoolName && (
            <div className="input__background">
              <span className="first__info">
                Escola: <span>{schoolName}</span>
              </span>
            </div>
          )}
          {disableSchoolYear && (
            <div className="input__background">
              <span className="first__info">
                Turma: <span>{NameTurma}</span>
              </span>
            </div>
          )}
          {disableDreAndMunicipio && disableDreTipoDeProva && (
            <div className="input__background">
              <span className="first__info">
                {/* Exemplo: REDE Juina | Juina |  */}
                Prova: <span>{DsPeriodo}</span>
              </span>
            </div>
          )}

        </div>
        <div className="basic__info">
          {disableDreAndMunicipio && (
            <div className="input__background">
              <span className="first__info">
                {/* Exemplo: REDE Juina | Juina |  */}
                REDE/Município: <span>{dreAndMunicipio}</span>
              </span>
            </div>
          )}
          {disableDreAndMunicipio && (
            <div className="input__background">
              <span className="first__info">
                {/* Exemplo: REDE Juina | Juina |  */}
                Série/Ano Escolar: <span>{SchoolYear}</span>
              </span>
            </div>
          )}
          {disableDreAndMunicipio && disableDreAno && (
            <div className="input__background">
              <span className="first__info">
                {/* Exemplo: REDE Juina | Juina |  */}
                Ano: <span>{DsAno}</span>
              </span>
            </div>
          )}

          {disableStudent && (
            <div className="input__background">
              <span className="first__info">
                Estudante: <span>{student}</span>
              </span>
            </div>
          )}
        </div>

      </div>
    </>
  );
};

HeaderRelatorioTurma.propTypes = {
  schoolName: PropTypes.string,
  SchoolYear: PropTypes.string,
  NameTurma: PropTypes.string,
  DsAno: PropTypes.string,
  DsPeriodo: PropTypes.string,
  dreAndMunicipio: PropTypes.string,
  student: PropTypes.string,
  disableSchoolYear: PropTypes.bool,
  disableDreAndMunicipio: PropTypes.bool,
  disableSchoolName: PropTypes.bool,
  disableStudent: PropTypes.bool,
  disableDreTipoDeProva: PropTypes.bool,
  disableDreAno: PropTypes.bool,
};
HeaderRelatorioTurma.defaultProps = {
  disableSchoolYear: true,
  disableDreAndMunicipio: true,
  disableSchoolName: true,
  disableStudent: true,
  disableDreTipoDeProva: true,
  disableDreAno: true
};

export default HeaderRelatorioTurma;
